<template>
  <div v-if="state.rules.visible">
    <component
      :is="getComponent()"
      v-model="state.field"
      @focus="focus"
      :disabled="state.field.validation.disabled || state.rules.disabled"
    />
  </div>
</template>

<script>
import { reactive, computed, watch } from 'vue';
import HrRadioField from '@/components/hr-radio-field.vue';
import HrCheckField from '@/components/hr-check-field.vue';
import HrInputField from '@/components/hr-input-field.vue';
import HrCoInput from '@/components/hr-co-input.vue';
import HrCountryField from '@/components/hr-country-field.vue';
import store from '@/store';
import rulesFunctions from '@/store/composables/document-rules';
import { validate } from '@/core/validation/validation';
import { buildRules, checkRules } from '@/core/build-rules';

export default {
  name: 'hr-tfn',
  components: {
    HrRadioField,
    HrCheckField,
    HrInputField,
    HrCountryField,
    HrCoInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value', 'focus'],
  setup(props, { emit }) {
    const FIELD_TYPES = {
      CHECK: HrCheckField,
      RADIO: HrRadioField,
      INPUT: HrInputField,
    };
    const state = reactive({
      field: computed({
        get: () => props.modelValue,
        set: (val) => {
          emit('update:model-value', { ...val });
        },
      }),
      fieldRules: store.state.Document.fieldRules,
      rules: {
        visible: rulesFunctions.visible.default(),
        disabled: rulesFunctions.disabled.default(),
        override: rulesFunctions.override.default(),
      },
    });
    watch(
      () => store.state.documents,
      () => {
        checkRules(state.field, state.fieldRules, state.rules);
      },
      {
        deep: true,
      }
    );

    function validateField() {
      validate(state.field);
    }

    function focus(value) {
      emit('focus', value);
    }

    function getComponent() {
      if (FIELD_TYPES[state.field.type]) {
        return FIELD_TYPES[state.field.type];
      } else if (
        state.field.name === 'tfnDeclaration.taxDetails.countryOfOrigin'
      ) {
        return HrCountryField;
      } else {
        return FIELD_TYPES['INPUT'];
      }
    }

    async function initialize() {
      if (state.field.validation && state.field.validation.rules) {
        buildRules(state.field, state.rules);
      }
      checkRules(state.field, state.fieldRules, state.rules);
    }

    initialize();

    return {
      state,
      focus,
      validateField,
      getComponent,
      FIELD_TYPES,
    };
  },
};
</script>
